import { AirflowUISpecCategory, UISpecCategory } from '@common/enums';
import { AirflowSpecLanguage, SpecLanguage } from '@common/types';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const SparkCategories = Object.values(UISpecCategory).filter(
  (item) => ![UISpecCategory.Hidden, UISpecCategory.Subgraph].includes(item)
);
const AirflowCategories = Object.values(AirflowUISpecCategory).filter(
  // exclude old categories
  (category) => ![AirflowUISpecCategory.Operator, AirflowUISpecCategory.Sensor].includes(category)
);
export function useGemsandLanguages(isAirflow: boolean) {
  let [searchParams] = useSearchParams();
  const gemTypes = useMemo(
    () =>
      (isAirflow ? AirflowCategories : SparkCategories).map((gemType) => ({
        label: gemType,
        value: gemType
      })),
    [isAirflow]
  );

  const languageOpts = Object.values(isAirflow ? AirflowSpecLanguage : SpecLanguage).map((lang) => ({
    label: lang,
    value: lang
  }));

  const language = useMemo<SpecLanguage | AirflowSpecLanguage>(() => {
    const defaulLanguage = isAirflow ? AirflowSpecLanguage.python : SpecLanguage.scala;
    const language = searchParams.get('lang') as SpecLanguage;
    return language || defaulLanguage;
  }, [isAirflow, searchParams]);

  const gemType = useMemo<UISpecCategory | AirflowUISpecCategory>(() => {
    const defaultGemType = isAirflow ? AirflowUISpecCategory.SparkSQL : UISpecCategory.SourceTarget;
    const gemType = searchParams.get('type') as UISpecCategory | AirflowUISpecCategory;
    return gemType || defaultGemType;
  }, [isAirflow, searchParams]);

  return {
    gemTypes,
    languageOpts,
    language,
    gemType
  };
}
